export default __webpack_public_path__ + "static/media/timer_background_l2.155d75a4.jpg";